
import { isServer } from '../device_detection/device_detection';
import { useServerRequestContext } from '../../views/__core/ServerRequestContextProvider/ServerRequestContextProvider';

/**
 *  returns the location corresponding to the client request
 * @returns object
 */
export const useLocation = () => {

  const serverRequestContext = useServerRequestContext();
  const location = isServer() ? new URL( serverRequestContext.request.href ) : global.location;
  return location;
}
